import paymentDetail from '@/constants/paymentDetail'

const mapField = (index, data) => {
  return {
    [`paymentCode_${index + 1}`]: data.paymentCode,
    [`paymentName_${index + 1}`]:
      data.paymentName + `${data.paymentName !== null && data.paymentName !== '' && data.type === 'change' ? ' (Change)' : ''}`,
    [`amount_${index + 1}`]: data.amount,
    [`processedAt_${index + 1}`]: data.processedAt,
    [`note_${index + 1}`]: data.note,
    [`ref_${index + 1}`]: data.referenceNumber
  }
}

const groudReportData = (reportDetail) => {
  let detail = {}
  reportDetail.forEach((data, index) => {
    detail = {
      ...detail,
      ...mapField(index, data)
    }
  })
  return detail
}

export const mapDataTable = (data) => {
  let sellReport = []
  data.forEach((report) => {
    const totalRefund = report?.paymentDetails?.filter((e) => e?.type === 'refund')?.reduce((prev, curr) => prev + (Number(curr?.amount) || 0), 0)
    if (!report.paymentDetails) {
      const detail = groudReportData(paymentDetail.type_3)
      sellReport = [...sellReport, { ...report, ...detail, totalRefund }]
    } else if (report.paymentDetails && report.paymentDetails.length === 2) {
      const paymentDetails = [...report.paymentDetails, ...paymentDetail.type_1]
      const detail = groudReportData(paymentDetails)
      sellReport = [...sellReport, { ...report, ...detail, totalRefund }]
    } else if (report.paymentDetails && report.paymentDetails.length === 1) {
      const paymentDetails = [...report.paymentDetails, ...paymentDetail.type_2]
      const detail = groudReportData(paymentDetails)
      sellReport = [...sellReport, { ...report, ...detail, totalRefund }]
    } else {
      const paymentDetails = [...report.paymentDetails]
      const detail = groudReportData(paymentDetails)
      sellReport = [...sellReport, { ...report, ...detail, totalRefund }]
    }
  })
  return sellReport
}
